import React from 'react'
import {Link} from 'gatsby'
import {css} from '@emotion/core'
import Carousel, {consts} from 'react-elastic-carousel'
import {useLocation} from '@reach/router'

import jumanjiCarousel from '../../img/customer-work/carousel/jumanji-carousel.jpg'
import pinkFloydCarousel from '../../img/customer-work/carousel/pink-floyd-carousel.jpg'
import sberbankCarousel from '../../img/customer-work/carousel/sberbank-carousel.jpg'
import jumanjiLogo from '../../img/customer-work/carousel/jumanji-logo.png'
import pinkFloydLogo from '../../img/customer-work/carousel/pink-floyd-logo.png'
import sberbankLogo from '../../img/customer-work/carousel/sberbank-logo.png'

const carouselItems: ICaseStudyCarouselItemData[] = [
  // Jumanji
  {
    image: jumanjiCarousel,
    logo: jumanjiLogo,
    h2: '>5',
    h4: 'min',
    p: 'avg. dwell time',
    link: '/customer-work/jumanji',
  },

  // Pink Floyd
  {
    image: pinkFloydCarousel,
    logo: pinkFloydLogo,
    h2: '2',
    h4: 'min',
    p: 'avg. dwell time',
    link: '/customer-work/pink-floyd',
  },

  // Sberbank
  {
    image: sberbankCarousel,
    logo: sberbankLogo,
    h2: '1M+',
    h4: '',
    p: 'user sessions',
    link: '/customer-work/sberbank',
    verticalMargin: '1.1em',
  },
]


export interface ICaseStudyCarouselItemData {
  image: string,
  logo: string,
  h2: string,
  h4: string,
  p: string,
  link: string,
  verticalMargin?: string,
  from?: string, // for a8 eventing
}

const CaseStudyCarouselCard: React.FunctionComponent<ICaseStudyCarouselItemData> = ({
  image,
  logo,
  h2,
  h4,
  p,
  link,
  from,
}) => (
  <Link
    to={link}
    className='case-study-card'
    a8={from && `click;${from};click-case-study-carousel-card`}
  >
    <div
      className='card shadow text-center'
      css={css`
      min-width: 0;
      min-height: 0;
      width: 275px;
      height: 500px;
      border-radius: 10px;
      margin: 2.5em 0;
      @media screen and (max-width: 767px) {
        width: 180px;
        height: 320px;
      }
    `}
    >
      <div
        css={css`
          height: 20%;
          display: flex;
        `}
      >
        <img
          src={logo}
          alt='Studio Logo'
          css={css`
            max-width: 70%;
            max-height: 60%;
            margin: auto;
          `}
        />
      </div>
      <div
        css={css`
          height: 60%;
        `}
      >
        <img
          src={image}
          alt='Studio Experience'
          css={css`
            max-width: 100%;
            max-height: 100%;
          `}
        />
      </div>
      <div className='case-study-card-body'>
        <h2 className='d-none d-md-inline card-title'>{h2}</h2>
        <h4 className='d-none d-md-inline'>{h4}</h4>
        <p className='d-none d-md-inline' style={{fontSize: '1.2em'}}>&nbsp;{p}</p>
        <div className='row justify-content-center'>
          <p
            style={{fontSize: '1.2em', fontFamily: 'Nunito, sans-serif', textDecoration: 'underline', color: '#7611B7'}}
          >Read case study
          </p>
        </div>
      </div>
    </div>
  </Link>
)

interface ICaseStudyCarousel {
  from?: string, // for a8 eventing
}

const CaseStudyCarousel:React.FunctionComponent<ICaseStudyCarousel> = ({
  from = '',
}) => {
  const {pathname} = useLocation()
  const carouselBreakPoints = [
    {width: 1, itemsToShow: 1.3},
    {width: 400, itemsToShow: 2.25, itemsToScroll: 1},
    {width: 850, itemsToShow: 3},
  ]

  const myArrow = ({type, onClick, isEdge}) => {
    const pointer = type === consts.PREV ? '‹' : '›'
    return (
      <button
        className='my-arrow'
        type='button'
        onClick={onClick}
        disabled={isEdge}
        css={css`
          font-size: 4em;
          color: #2D2E43;
          outline: none !important;
          @media screen and (max-width: 767px) {
            display: none;
          }
        `}
      >
        {pointer}
      </button>
    )
  }

  return (
    <div className='row justify-content-center'>
      <div className='col' style={{maxWidth: '1200px'}}>
        <Carousel
          renderArrow={myArrow}
          breakPoints={carouselBreakPoints}
          itemPadding={[0, 50]}
        >
          {carouselItems.reduce<React.ReactElement[]>((o, v) =>
            // TODO(kyle): uncomment below when there are more than 3 case studies
            // const currentPath = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname
            // if (v.link === currentPath) { // Exclude current case-study from carousel.
            //   return o
            // }
            // eslint-disable-next-line implicit-arrow-linebreak
            o.concat(
              <CaseStudyCarouselCard
                from={from}
                key={v.link}
                {...v}
              />
            ),
          [])}
        </Carousel>
      </div>
    </div>
  )
}

export {CaseStudyCarousel, CaseStudyCarouselCard, carouselItems}
